'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "@/components/Button";
import {hover, marengo, text, white} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";
import {toast} from "react-toastify";
import Title from "@/components/Title";
import Link from "next/link";
import {useForm} from "react-hook-form";
import axios from "axios";
import useContainerOffset from "@/components/hooks/useContainerOffset";


const SubscribeForm = ({title, img, link, form_id, form_tag, pdf, handleClose}) => {

    const [IsSubmitting, setIsSubmitting] = useState(true);
    const offset = useContainerOffset('.container');
    useEffect(() => {
        setTimeout(() => {
            setIsSubmitting(false);
        }, 300);
    }, []);

    const {register, handleSubmit, formState, reset} = useForm({mode: "all"});
    const {errors, isSubmitSuccessful, isSubmitting} = formState;


    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    // // form submit
    const [reg, setReg] = useState({
        name: "",
        department: "",
        phone: "",
        email: "",
        msg: "",
    });


    const onSubmit = async (data) => {
        setIsSubmitting(true); // Show spinner
        try {
            const formData = new FormData();
            formData.append("your-name", data?.name);
            formData.append("phone", data?.phone);
            formData.append("email", data?.email);
            formData.append("status", 'C');
            formData.append("list", 1);
            formData.append("_wpcf7_unit_tag", "form_b6a2e3d");

            // const response = await axios.post(
            //     `https://cms.ups-bd.com/wp-json/newsletter/v2/subscriptions`,
            //     formData
            // );

            const response = await axios.post(
                `https://cms.ups-bd.com/wp-json/contact-form-7/v1/contact-forms/247/feedback`,
                formData
            );
            if (response.status === 200) {
                console.log(response, 'submit form')
                success(response?.data?.message);
                reset(); // Reset form fields
            }  else if (response.status === 201) {
                success('Subscribed Successfully');
                reset(); // Reset form fields
                if(pdf){
                   setTimeout(() => {
                       window.open(pdf, "_blank");
                   }, 1000)

                }

            } else {
                error("Failed to submit form. Please try again later.");
            }
        } catch (err) {
            // error(
            //     err?.message
            //         ? err?.message
            //         : "Failed to submit form. Please try again later."
            // );
            success('Already Subscribed');

        } finally {
            setIsSubmitting(false); // Hide spinner
        }
    };

    const onError = (errors) => {
        // setToastShown(false); // Reset toast shown state on new submission attempt
        const firstError = Object.values(errors)[0];
        error(firstError.message);
    };



    return (
        (<StyledGetInTouch offset={offset} className="enquiry">
            <Container  fluid>
                <Row>
                    <Col xs={12} sm={12} md={4} className='contact-from-right pr-0'>
                        <Title noanim text={'Stay connected with us!'} margin={'0 0 10px'} color={'white'} />
                        <p>Get all the latest updates easily</p>
                    </Col>
                    <Col xs={12} sm={12} md={8} className='contact-from-left pl-0'>
                        <div className='contact-from-left__inner'>
                            <Form className={'form'}>
                                <Form.Group className={'name-group'} controlId="formBasicEmail">
                                    <Form.Control
                                        className={
                                            formState?.errors?.name?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("name", {
                                            required: "Enter your full name",
                                            pattern: {
                                                value: /^[A-Za-z ]+$/,
                                                message: "Name must contain only letters",
                                            },
                                        })}
                                        type="text"
                                        placeholder="Name*"
                                        disabled={isSubmitting}
                                    />
                                    {errors.name && (
                                        <span className="error-message form-error">
                      {errors.name.message}
                    </span>
                                    )}
                                </Form.Group>

                                <div className="form-group">
                                    <Form.Group controlId="formBasicPhone">
                                        <Form.Control
                                            className={
                                                formState?.errors?.phone?.message
                                                    ? "has-error form-control-lg"
                                                    : "form-control-lg"
                                            }
                                            {...register("phone", {
                                                required: {
                                                    value: true,
                                                    message: "Enter your phone number",
                                                },
                                                pattern: {
                                                    value: /^01[0-9]{9}$/,
                                                    message: "Enter a valid 11 digit phone number",
                                                },
                                            })}
                                            type="number"
                                            placeholder="Phone / WhatsApp*"
                                            disabled={isSubmitting}
                                        />
                                        {errors.phone && (
                                            <span className="error-message form-error">
                        {errors.phone.message}
                      </span>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className="phoneEmail">
                                    <div className="form-group">
                                        <Form.Group controlId="formBasicEmail">
                                            <Form.Control
                                                className={
                                                    formState?.errors?.email?.message
                                                        ? "has-error form-control-lg"
                                                        : "form-control-lg"
                                                }
                                                {...register("email", {
                                                    required: {
                                                        value: false,
                                                        message: "Enter a valid email address",
                                                    },
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: "Enter a valid email address",
                                                    },
                                                })}
                                                type="email"
                                                placeholder="Email"
                                                disabled={isSubmitting}
                                            />
                                            {errors.email && (
                                                <span className="error-message form-error">
                        {errors.email.message}
                      </span>
                                            )}
                                        </Form.Group>
                                    </div>
                                </div>


                                <div className={'button-group'}
                                     style={{width: "fit-content"}}
                                     onClick={handleSubmit(onSubmit, onError)}
                                >
                                    <Button text={'Connect'} src={"javascript:void(0)"}
                                            border={`1px`}
                                            borderColor={`${white}`}
                                            hoverBackground={`${hover}`}
                                            color={`${white}`}
                                            padding={'10px 20px'}
                                    />
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </StyledGetInTouch>)
    );
};


const StyledGetInTouch = styled.section`

    h2 {
        font-weight: 800;
    }

    .contact-from-right {
        padding-left: ${probs => probs.offset ? probs.offset + 15 : ''}px;
        padding-right: ${probs => probs.offset ? probs.offset + 15 : ''}px !important;
        background: rgb(26, 71, 148);
        padding-top: 30px;
        padding-bottom: 30px;

        p {
            color: white;
        }
    }

    .contact-from-left {
        padding-right: 0;


        &__inner {
            background-color: ${marengo};
            padding: 30px;
            height: 100%;
            display: flex;
            align-items: center;

            h3 {
                font-size: 40px;
                font-weight: 700;
                line-height: 46px;
                color: ${text};
                margin-bottom: 0;
            }

            .form {
                display: flex;
                gap: 30px;
            }

            .form-group {
                margin-bottom: 0 !important;
            }

            .form-control {
                height: 50px;
                color: ${white};
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                border-radius: 0;
                border: none;
                border-bottom: 1px solid #D1D1D1;
                background-color: transparent;
                padding: 0;
                margin-bottom: 0 !important;

                &::placeholder {
                    font-size: 14px;
                    color: ${white};
                    opacity: .6;
                    line-height: 20px;
                    font-weight: 500;
                    margin-bottom: 15px;
                }
            }
        }
    }

    @media (min-width: 1550px) {
        .contact-from-right {
            &__image {
                padding-top: calc(800 / 822 * 100%);
            }
        }

        .contact-from-left {
            &__inner {

                h3 {
                    font-size: 48px;
                    line-height: 56px;
                }

                .form-control {
                    font-size: 16px !important;
                }
            }
        }
    }


    @media (max-width: 767px) {
        h2 {
            margin-bottom: 0;
        }

        .form {
            flex-direction: column;
            max-width: 100%;
            width: 100%;
        }

        .name-group, .button-group, .phoneEmail {
            max-width: 100%;
            width: 100%;
            flex: 0 0 100%;

            .form-control {
                width: 100%;
            }
        }
    }
`

export default SubscribeForm;